import { createContext, useContext, useEffect, useState } from "react";
import { API } from "@/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    (async () => {
      if (!localStorage.getItem("tf_token")) {
        setUser(null);
        return;
      }
      try {
        const { data } = await API.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("tf_token");
        setUser(null);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await API.post("/auth/login", { email, password });
    localStorage.setItem("tf_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("tf_token");
    setUser(null);
  };

  return <Ctx.Provider value={{ user, setUser, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
